import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';
import { baseProductApiUrl } from '../..';
import { AxiosRequestConfig } from 'axios';
import { getImpersonationHeader } from '../../helpers';

export const getFromHamsClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.get(`${baseProductApiUrl}${remainingPath}`, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
